import { useCallback } from 'react';
import { useHistory } from 'react-router';
import { useApp } from 'Shared/utils/hooks/use-app';

// Utils
import PageUrlsUtils from 'Shared/utils/PageUrls.utils';

type handleFocusWorkspaceItemProps = {
  workspaceId: string;
};

export function useHandleFocusWorkspaceItem({ workspaceId }: handleFocusWorkspaceItemProps) {
  const history = useHistory();
  const { isZoom } = useApp();

  const handleFocusWorkspaceItem = useCallback(
    itemUuid => {
      if (!isZoom) {
        history.push(PageUrlsUtils.makeWorkspaceMeetingItemUrl(workspaceId, itemUuid));
      }
    },
    [history, isZoom, workspaceId]
  );

  return handleFocusWorkspaceItem;
}
